export function isValidCmsLink(linkUrl: unknown): linkUrl is string {
  if (typeof linkUrl !== 'string' || !linkUrl.trim()) {
    return false
  }

  const normalizedLinkUrl = linkUrl.trim()

  if (normalizedLinkUrl.startsWith('/')) {
    return !normalizedLinkUrl.startsWith('//')
  }

  try {
    const { protocol } = new URL(normalizedLinkUrl)

    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}
